import * as Documents from './documents.action';
import * as Layout from './layout.action';
import * as TableFilters from './table-filters.action';
import * as Table from './table.action';
import * as CheckedDocuments from './checked-documents.action';

export {
    Documents,
    Layout,
    TableFilters,
    Table,
    CheckedDocuments
};
